import { render, staticRenderFns } from "./DiagnosticProcedureRequestForm.vue?vue&type=template&id=43adfaca&scoped=true"
import script from "./DiagnosticProcedureRequestForm.vue?vue&type=script&lang=js"
export * from "./DiagnosticProcedureRequestForm.vue?vue&type=script&lang=js"
import style0 from "./DiagnosticProcedureRequestForm.vue?vue&type=style&index=0&id=43adfaca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43adfaca",
  null
  
)

export default component.exports